import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  @Input()
  notificationTitle = 'title';

  @Input()
  notificationType = 'BLOCK_TOAST';

  @Input()
  notificationBodyContent = 'bodyContent';

  @Input()
  dislayCloseButton = true;

  @Input()
  displayLeaveButton = false;

  @Input()
  displayStayButton = false;

  @Input()
  viewButton;


  @Output() closeNotificationEvent = new EventEmitter<boolean>();

  @Output() leaveNotificationEvent = new EventEmitter<boolean>();

  @Output() stayOnPageNotificationEvent = new EventEmitter<boolean>();
  
  @Output() viewNotificationEvent = new EventEmitter<boolean>();

  notificationBodyArray: string[] = [];

  constructor(
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {

    this.viewButton = this.viewButton ? this.viewButton : false;

    if (this.notificationBodyContent !== null) {
      this.notificationBodyArray = this.notificationBodyContent.split('::');
    }

  }

  raiseNotificationEvent(eventAction) {


    if (eventAction === 'stay') {
      this.stayOnPageNotificationEvent.emit(true);
    } else if (eventAction === 'leave') {
      this.leaveNotificationEvent.emit(true);
    } else if (eventAction === 'close') {
      this.closeNotificationEvent.emit(true);
    } else if (eventAction === 'view') {
      this.viewNotificationEvent.emit(true);
    }
  }

}
